import { brunaWosChatEnabled } from "../services/bruna-web-door";

/**
 * Decide se o chat flutuante fala com a Bruna (porta web, pelo api-gateway) em vez da
 * Lia (`VITE_AGENT_BASE_URL`), PED-14548.
 *
 * Sem feature flag: o ambiente com `VITE_BRUNA_WOS_CHAT=true` usa a Bruna; sem ela,
 * segue na Lia.
 */
export function useBrunaWosChat(): boolean {
  return brunaWosChatEnabled();
}
